export const countOfGeoRankPointsAwardedPlayers = (rankingType, gameMode) => {
    if (rankingType === 'regular') {
        switch (gameMode) {
            case 'overall': return 5000;
            case 'moving': return 2500;
            case 'nomove': return 3000;
            case 'nmpz': return 500;
        }
        return 5000;
    }
    if (rankingType === 'pro') {
        return 100;
    }
    if (rankingType === 'elite') {
        return 30;
    }
    return null;
}